module.exports = __webpack_public_path__ + "img/Watney0.0be60e7a.jpg";